<wr-new-data-table headerText="Gebäudeanträge"
                   localStorageIdentifier="building-application-overview"
                   [loadItemsFunction]="loadBuildingApplications"
                   [getCountFunction]="getCount"
                   (lineClick)="navigateToBuildingApplication($event)"
                   (newClick)="add()"
                   [form]="form"
                   [isAdmin]="canCreateBuildingApplications()">
  <ng-template dataTableFilter>
    <form [formGroup]="form">
      <div class="filter-form">
        <div class="filter-control-group">
          <label class="label" for="textFilter">Textfilter</label>
          <input type="text" nbInput id="textFilter" formControlName="textFilter" placeholder="Filter Text...">
        </div>
        @if (tenant()?.type === TenantTypeEnum.Internal) {
        <div class="filter-control-group">
          <label class="label" for="tenantSelect">Kunden</label>
          <wr-tenant-select id="tenantSelect"
                            formControlName="ownerTenantId"
                            [tenantType]="TenantTypeEnum.External"
                            [showEmptyOption]="true">
          </wr-tenant-select>
        </div>
        }
        <div class="filter-control-group">
          <label class="label" for="status">Status</label>
          <wr-application-status-select id="status"
                                        formControlName="status"
                                        [showEmptyOption]="true">
          </wr-application-status-select>
        </div>

      </div>
    </form>
  </ng-template>
  <ng-template
    dataColumn
    let-buildingApplication
    key="address"
    [sortable]="false"
    exportKey="baseData.sectionText"
    display="Adresse">
    @if (buildingApplication.baseData.sectionText) {
      {{ buildingApplication.baseData.sectionText }}
    }
  </ng-template>
  <ng-template
    dataColumn
    let-buildingApplication
    key="ownerTenant"
    [sortable]="false"
    exportKey="ownerTenant.name"
    display="Kunde">
    <wr-tenant-badge [tenant]="buildingApplication.ownerTenant"></wr-tenant-badge>
  </ng-template>
  <ng-template
    dataColumn
    let-buildingApplication
    key="area"
    [sortable]="false"
    exportKey="baseData.area"
    [exportDecimals]="2"
    display="Fläche">
    @if (buildingApplication.baseData.area) {
      {{ buildingApplication.baseData.area | number: '1.2-2'}}&nbsp;m²
    }
  </ng-template>
  <ng-template
    dataColumn
    let-buildingApplication
    key="status"
    display="Status"
    [sortable]="false">
    <wr-application-status-badge [buildingApplicationItemDto]="buildingApplication"></wr-application-status-badge>
  </ng-template>
</wr-new-data-table>
